module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-img.767e60cc.png";